import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { usePresse } from '../../api/presse.js';
import { estApiError } from '../../api/errors.js';
import styles from './PressePage.module.css';
export function SectionPresse({
  galerieSlug,
  filtre,
}: {
  galerieSlug: string;
  filtre: { expositionId?: string; artisteId?: string };
}) {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const presse = usePresse(galerieSlug, { ...filtre, parPage: 5 });
  return (
    <section className={styles.section} data-ui="press-section">
      <h2>{t('regie:presse.titre')}</h2>
      {presse.isError ? (
        <p role="alert">
          {estApiError(presse.error) ? presse.error.message : t('commun:erreurReseau')}
        </p>
      ) : null}
      <ul>
        {presse.data?.articles.map((a) => (
          <li key={a.id}>
            <Link to={`/${galerieSlug}/presse/${a.id}`}>{a.titre}</Link>
            <span>{a.support}</span>
            {a.paruLe ? (
              <time dateTime={a.paruLe}>
                {new Intl.DateTimeFormat(i18n.language, {
                  dateStyle: 'medium',
                  timeZone: 'Europe/Paris',
                }).format(new Date(`${a.paruLe}T12:00:00Z`))}
              </time>
            ) : null}
          </li>
        ))}
      </ul>
      {presse.data && !presse.data.articles.length ? <p>{t('regie:presse.vide')}</p> : null}
      <Link to={`/${galerieSlug}/presse?${new URLSearchParams(filtre)}`}>
        {t('regie:presse.voirTout')}
      </Link>
    </section>
  );
}
